import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { G } from "@/brand";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LogOut } from "lucide-react";
import { ComingSoonModal } from "@/components/ComingSoonModal";

export function Nav() {
  const { user, logout, requireAuth } = useAuth();
  const nav = useNavigate();
  const [soon, setSoon] = useState(false);
  const loggedIn = user && user.email;

  return (
    <>
    <nav style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 200, padding: "32px 5vw",
      background: G.creme, borderBottom: "1px solid #ddd0aa",
      boxShadow: "0 2px 12px rgba(0,0,0,.3), 0 1px 0 #d4c488",
      display: "flex", alignItems: "center", justifyContent: "space-between",
    }} data-testid="main-nav">
      <Link to="/" data-testid="nav-logo" style={{ textDecoration: "none", display: "flex", alignItems: "baseline", gap: 6 }}>
        <span className="mono" style={{ fontWeight: 700, fontSize: 14, letterSpacing: "0.25em", color: G.gold }}>PROMPT</span>
        <span className="mono" style={{ fontWeight: 400, fontSize: 14, letterSpacing: "0.25em", color: "#1a1408" }}>SAVANT</span>
      </Link>

      <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
        <Link to="/library" data-testid="nav-library" className="mono" style={navLink}>Library</Link>
        <Link to="/pricing" data-testid="nav-pricing" className="mono" style={navLink}>Pricing</Link>
        <button data-testid="nav-coming-soon" onClick={() => setSoon(true)} className="mono" style={navLink}>Coming Soon</button>

        {loggedIn ? (
          <>
            <div data-testid="nav-credits" className="mono" title="Credit balance" style={{
              display: "flex", alignItems: "center", gap: 6, padding: "7px 14px",
              border: `1px solid ${G.gold}`, color: G.gold, fontSize: 11, letterSpacing: ".1em",
            }}>
              <Sparkles size={13} /> {user.credit_balance} CR
            </div>
            <Link to="/dashboard" data-testid="nav-dashboard" className="btn-outline" style={{ padding: "8px 16px", fontSize: 10, textDecoration: "none" }}>
              Dashboard
            </Link>
            {user.role === "admin" && (
              <Link to="/admin" data-testid="nav-admin" className="mono" style={navLink}>Admin</Link>
            )}
            <button data-testid="nav-logout" onClick={() => { logout(); nav("/"); }} title="Log out" style={{
              background: "none", border: "none", cursor: "pointer", color: G.goldDim, display: "flex", alignItems: "center",
            }}><LogOut size={16} /></button>
          </>
        ) : (
          <button data-testid="nav-signin" onClick={() => requireAuth("")} className="btn-gold" style={{ padding: "8px 22px", fontSize: 10 }}>
            Sign In
          </button>
        )}
      </div>
    </nav>
    <ComingSoonModal open={soon} onClose={() => setSoon(false)} />
    </>
  );
}

const navLink = {
  textDecoration: "none", background: "transparent", border: "none", cursor: "pointer",
  color: G.goldDim, letterSpacing: ".15em", textTransform: "uppercase", fontSize: 10, padding: "7px 6px",
};
